import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { GenericDaterangeInputModule, GenericDecimalInputModule, GenericInputModule, GenericSelectInputModule, GenericTextInputModule } from '@sla-ng/ui-material';
import { CostCenterCostComponent } from './components/cost-center-cost/cost-center-cost.component';
import { CostTypeCostComponent } from './components/cost-type-cost/cost-type-cost.component';
import { CostAccountingErrorDialogComponent } from './components/error-dialog/cost-accounting-error-dialog.component';
import { CostCenterCostHistoryDialogComponent } from './components/history-dialog/cost-center-cost-history-dialog.component';
import { RebookingDialogComponent } from './components/rebooking-dialog/rebooking-dialog.component';
import { CostAccountingDialogComponent } from './cost-accounting-dialog.component';
import { ImportIndirectCostComponent } from './components/import-indirect-cost/import-indirect-cost.component';

export * from './cost-accounting-dialog.component';

@NgModule({
    declarations: [
        CostAccountingDialogComponent,
        CostCenterCostComponent,
        RebookingDialogComponent,
        CostCenterCostHistoryDialogComponent,
        CostTypeCostComponent,
        ImportIndirectCostComponent,
        CostAccountingErrorDialogComponent
    ],
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        GenericInputModule,
        TranslateModule,
        GenericDaterangeInputModule,
        GenericSelectInputModule,
        ReactiveFormsModule,
        MatMenuModule,
        MatIconModule,
        GenericTextInputModule,
        GenericDecimalInputModule,
        MatDividerModule,
        MatTooltipModule,
        MatStepperModule,
        MatProgressBarModule,
        MatStepperModule,
        MatTableModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule,
        MatTabsModule,
        MatDatepickerModule,
        MatSelectModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        MatAutocompleteModule,
    ],
})
export class CostAccountingDialogModule {
}
